// =========================================================
// MASQUAGE ANTI-SPAM des tel: / mailto: — le numéro/l'adresse est remplacé
// par « Voir le numéro » / « Voir l'email » jusqu'au 1er clic (les bots ne
// scrapent pas, l'utilisateur clique pour révéler puis re-clique pour agir).
//
// v2 (13/07, KM Matériaux) : gère les liens CONTENANT DU MARKUP (icônes <i>
// des pilules .km-btn — l'ancien garde isHTML les sautait purement, vécu) en
// ne remplaçant QUE les nœuds texte ; libellé résolu par préfixe de langue
// (un site en fr-BE affichait « undefined » avec l'index fr-FR strict).
// =========================================================

//Textes
const hideTelText = {
    "fr": "Voir le numéro",
    "en": "Show the number",
    "nl": "Zie nummer",
    "es": "Ver numero"
}
const hideMailText = {
    "fr": "Voir l'email",
    "en": "Show the email",
    "nl": "Zie email",
    "es": "Ver email"
}

// Libellé par préfixe de langue (fr-FR, fr-BE… → fr), repli français
function pickLabel(map, lang) {
    const prefix = (lang || 'fr').toLowerCase().split('-')[0];
    return map[prefix] || map.fr;
}

// Masque un lien : remplace ses nœuds TEXTE par le libellé (les icônes et
// autres balises restent en place), retire le href ; le 1er clic restaure tout.
function hideLink(el, label, hiddenClass, visibleClass) {
    if (!el.textContent.trim()) return; // lien 100% icône : rien à masquer

    el.classList.add(hiddenClass);
    el.dataset.dataHref = el.href;
    el.dataset.dataOriginal = el.innerHTML;
    // href auto-référent (pas de removeAttribute : un <a> sans href = « lien
    // non explorable » à l'audit agentique, vécu) — le clic est preventDefault
    el.setAttribute('href', window.location.pathname);

    let labelSet = false;
    [...el.childNodes].forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = labelSet ? '' : label;
            labelSet = true;
        }
    });

    el.addEventListener('click', function reveal(e) {
        // el (closure), PAS e.target : le clic peut tomber sur l'icône interne
        e.preventDefault();
        el.innerHTML = el.dataset.dataOriginal;
        el.href = el.dataset.dataHref;
        el.classList.remove(hiddenClass);
        el.classList.remove(visibleClass);
        el.removeEventListener('click', reveal);
    });
}

//DOM loaded
document.addEventListener("DOMContentLoaded", () => {
    const pageLang = document.documentElement.lang;

    //Masque les numéros de téléphone
    document.querySelectorAll('a[href^="tel:"]:not([data-no-hide])').forEach((el) => {
        hideLink(el, pickLabel(hideTelText, pageLang), 'pdw-tel-hidden', 'pdw-tel-visible');
    });

    //Masque les adresses email
    document.querySelectorAll('a[href^="mailto:"]:not([data-no-hide])').forEach((el) => {
        hideLink(el, pickLabel(hideMailText, pageLang), 'pdw-mailto-hidden', 'pdw-mailto-visible');
    });

});
